import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { WarningIcon } from "../icons";
import { Typography } from "../Typography";
import { COLUMN_POSITION_ENDS, COLUMN_POSITION_STARTS } from "../types";
export const InputWrapper = ({ label, hideLabel = false, helperText, size = "medium", errorText, orientation = "vertical", labelColumnStart = 2, labelColumnEnd = 5, inputColumnStart = 7, inputColumnEnd = 13, isDisabled, isReadonly, isRequired, className = "", render, hasMinimumWidth = true, backgroundStyle = "transparent", labelHtmlFor, }) => {
    const labelClasses = [
        size === "large" && ["text-md", "mt-1.5"],
        size === "medium" && ["text-sm", "mt-1"],
        size === "small" && ["text-sm", "mt-0.75"],
    ];
    const isVisuallyEnabled = !isDisabled && !isReadonly;
    const hasBackgroundFill = backgroundStyle === "filled";
    const inputClasses = classNames([
        !errorText &&
            isVisuallyEnabled && [
            "border-border-regular",
            "dark:border-border-regular-darkmode",
            "border",
            "text-text-primary dark:text-text-primary-darkmode",
        ],
        errorText &&
            isVisuallyEnabled && [
            "border-border-critical",
            "dark:border-border-critical-darkmode",
            "border-2",
        ],
        !isVisuallyEnabled && [
            "dark:bg-background-disabled-darkmode",
            "bg-background-disabled",
            "border-border-subdued",
            "dark:border-border-subdued-darkmode",
            "border",
        ],
        isVisuallyEnabled &&
            (hasBackgroundFill
                ? "bg-background-primary dark:bg-background-primary-darkmode"
                : "bg-transparent"),
        isVisuallyEnabled && "text-text-primary dark:text-text-primary-darkmode",
        isDisabled && "text-text-subdued dark:text-text-subdued-darkmode",
        "focus:outline",
        "focus:outline-1",
        "focus:outline-border-brand",
        "dark:focus:outline-border-brand-darkmode",
        "placeholder-text-subdued",
        "dark:placeholder-text-subdued-darkmode",
        "rounded",
        "border-solid",
        hasMinimumWidth && "min-w-[112px]",
        "w-full",
        "px-1",
        size === "large" && ["py-1", "text-lg"],
        size === "medium" && ["py-0.75", "text-md"],
        size === "small" && ["py-0.25", "text-md"],
    ]);
    return (_jsx("label", { className: className, "aria-label": hideLabel ? label : "", htmlFor: labelHtmlFor, children: _jsxs("div", { style: { overflowWrap: "anywhere" }, className: classNames(orientation === "horizontal" && "grid grid-cols-12"), children: [_jsxs("div", { className: classNames(label && !hideLabel && "mb-0.5", orientation === "horizontal" && [
                        COLUMN_POSITION_STARTS[labelColumnStart],
                        COLUMN_POSITION_ENDS[labelColumnEnd],
                    ], errorText
                        ? [
                            "font-semibold",
                            "text-text-critical",
                            "dark:text-text-critical-darkmode",
                        ]
                        : "text-text-subdued dark:text-text-subdued-darkmode", label && !hideLabel && labelClasses), children: [isRequired && (_jsx("span", { className: "text-text-attention dark:text-text-attention-darkmode mr-0.5 before:content-['*']" })), !hideLabel && label] }), _jsxs("div", { className: classNames(orientation === "horizontal" && [
                        COLUMN_POSITION_STARTS[inputColumnStart],
                        COLUMN_POSITION_ENDS[inputColumnEnd],
                    ]), children: [render({ inputClasses, isReadonly, isDisabled }), errorText && (_jsxs("div", { className: "text-text-critical dark:text-text-critical-darkmode font-semibold text-sm mt-0.5", children: [_jsx(WarningIcon, { className: "mr-0.5", size: "sm" }), errorText] })), helperText && (_jsx(Typography, { variant: "body-small", color: "text-subdued", className: "mt-0.5", children: helperText }))] })] }) }));
};
//# sourceMappingURL=InputWrapper.js.map